// @ts-strict-ignore
import { Component, inject, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface ConfirmDialogInterface {
  message: string;
  title: string;
  buttons: ConfirmButtons[];
}

interface ConfirmButtons {
  text: string;
  buttonClass: string;
  returnValue: boolean;
}

@Component({
  selector: 'confirm',
  templateUrl: './confirm.dialog.html',
  styleUrl: './confirm.dialog.scss',
})
export class ConfirmDialogComponent implements OnInit {
  public message: string = '';
  public title: string = '';
  public buttons: ConfirmButtons[];
  public hideCancelButton: boolean;
  public accessibilityMode: boolean;
  public disconnectedMsg = false;
  public dialogRef: MatDialogRef<ConfirmDialogComponent> = inject(MatDialogRef);

  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogInterface) {
    this.message = data.message;
    this.title = data.title;
    this.buttons = data.buttons ? data.buttons : [];
  }

  public ngOnInit(): void {
    setTimeout(() => {
      if (JSON.parse(localStorage.getItem('accessibility'))) {
        this.accessibilityMode = JSON.parse(
          localStorage.getItem('accessibility'),
        );
      }
    }, 200);
    if (this.title === 'Disconnected') {
      this.disconnectedMsg = true;
    }
  }

  public confirm(value: boolean): void {
    this.dialogRef.close(value);
  }

  public trackByIndex(index: number): number {
    return index;
  }
}
